<script>
  import { Slider } from 'element-ui'
  export default {
    name:'ElSlider',
    extends:Slider
  }
</script>
